import { h1 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const BGImage = styled(GatsbyImage)`
    background-size: cover;
    background-position: center;
    position: absolute;
    top: -7rem;
    left: -8%;
    height: 343%;
    width: 75rem;
    -webkit-transform: rotate(-20deg);
    -ms-transform: rotate(-20deg);
    transform: rotate(-20deg);
    opacity: .05;
    z-index: 1;
`;

const S = {
    BGImage
};

export default S;
